// Reads window._env_ from /env-config.js, written by scripts/config/write-env-config.js at container start / before yarn start
const runtimeConfig = (typeof window !== 'undefined' && window._env_) || {};

export const getEnv = (name, fallback = '') => {
  const value = runtimeConfig[name];
  return value === undefined || value === null || value === '' ? fallback : String(value);
};

export const getEnvBase64 = (name) => {
  const value = getEnv(name);
  if (!value) return '';
  try {
    return window.atob(value);
  } catch (e) {
    return '';
  }
};

export const REQUIRED_ENV = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN',
  'REACT_APP_FIREBASE_DATABASE_URL',
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_APP_ID',
  'REACT_APP_RECAPTCHA_ENTERPRISE_SITE_KEY',
  'REACT_APP_GOOGLE_MAPS_API_KEY',
  'REACT_APP_GOOGLE_WEB_CLIENT_ID',
  'REACT_APP_SIGNED_REQUEST_PRIVATE_KEY_PEM_BASE64',
];

export const getMissingEnv = () => REQUIRED_ENV.filter((name) => !getEnv(name));
